// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spin_spinner__wxN0t","rotate":"Spin_rotate__Lpo4N","hidden":"Spin_hidden__porb9","path":"Spin_path__IB7R8","dash":"Spin_dash__9uvyD"};